export default "__VITE_ASSET__Dhmj616m__"